import React, { forwardRef, useState, useImperativeHandle } from "react";
import "./index.scss";

const ErrorHandler = forwardRef(function ErrorHandler(_props, ref) {
  const [errors, setErrors] = useState<Array<string>>([]);
  const timerError = (duration: number) => {
    setTimeout(() => {
      setErrors((errors) => {
        const newErrs = [...errors];
        newErrs.splice(0, 1);
        return newErrs;
      });
    }, duration);
  };
  useImperativeHandle(ref, () => {
    return {
      show(err: string, duration: number = 2000) {
        setErrors((errs) => [err, ...errs]);
        timerError(duration);
      },
    };
  });
  return (
    <div className="error-handler__container">
      {errors.map((err, idx) => {
        return (
          <div className="error-item" key={idx}>
            <span className="error-text">{err}</span>
          </div>
        );
      })}
    </div>
  );
});

export default ErrorHandler;
